import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { Provider } from 'react-redux';
import store from './store';
import LoginPage from './pages/LoginPage';
import SignUpPage from './pages/SignUpPage';
import RequestFormPage from './pages/RequestFormPage';
import LandingPage from './pages/LandingPage';
import RequestList from './components/requests/RequestList';
import RequestSchedulePage from './pages/RequestSchedulePage';
import AdminLandingPage from './pages/AdminLandingPage';
// Página de pruebas de componentes: su ruta /component está comentada más abajo. Descomentar ambas para usarla.
// import ComponentDevPage from './pages/ComponentDevPage';
import CartPage from './pages/CartPage';
import AddProductPage from './pages/AddProductPage';
import AdminProductsPage from './pages/AdminProductsPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import ManageUsersPage from './pages/ManageUsersPage';
import ManageWorkshopsPage from './pages/ManageWorkshopsPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ProfilePage from './pages/ProfilePage';
import ProtectedRoute from './components/auth/ProtectedRoute';

const IndicatorsPage = lazy(() => import('./pages/IndicatorsPage'));
const IndicatorSettingsPage = lazy(() => import('./pages/IndicatorSettingsPage'));
const IndicatorsReportPage = lazy(() => import('./pages/IndicatorsReportPage'));

const ADMIN_ROLES = ['admin', 'panolero'];

function App() {
  return (

    <Provider store={store}>
      <Router>
        <Suspense fallback={<div style={{ padding: 48, textAlign: 'center' }}>Cargando…</div>}>
        <Routes>
          {/* RUTAS */}
          <Route exact path='/' element={<LoginPage />} />
          <Route exact path='/forgot_password' element={<ForgotPasswordPage />} />
          <Route exact path='/singin' element={<SignUpPage />} />
          <Route exact path='/request' element={<RequestFormPage />} />
          <Route exact path='/request/:idPedido' element={<RequestFormPage />} />
          <Route exact path='/fechas' element={<RequestSchedulePage />} />
          <Route exact path='/fechas/:taller/:descp' element={<RequestSchedulePage />} />
          <Route exact path='/fechas/:taller/:descp/:idPedido' element={<RequestSchedulePage />} />
          <Route exact path='/landing' element={<ProtectedRoute element={<LandingPage />} />} />
          <Route exact path='/api/pedidos/:id_usuario' element={<ProtectedRoute element={<RequestList />} />} />
          <Route exact path='/landingadmin' element={<ProtectedRoute element={<AdminLandingPage />} allowedRoles={ADMIN_ROLES} />} />
          {/* <Route exact path='/component' element={<ComponentDevPage />} /> */}

          <Route exact path='/carroproductos' element={<CartPage />} />
          <Route exact path='/AgregarProductos' element={<AddProductPage />} />
          <Route exact path='/ListaProductos' element={<ProtectedRoute element={<AdminProductsPage />} allowedRoles={ADMIN_ROLES} />} />
          <Route exact path='/CambioContrasena' element={<ChangePasswordPage />} />
          <Route exact path='/perfil' element={<ProtectedRoute element={<ProfilePage />} />} />
          <Route exact path='/GestionarUsuarios' element={<ProtectedRoute element={<ManageUsersPage />} allowedRoles={ADMIN_ROLES} />} />
          <Route exact path='/GestionarTalleres' element={<ProtectedRoute element={<ManageWorkshopsPage />} allowedRoles={ADMIN_ROLES} />} />
          <Route path='/indicadores/configuracion' element={<ProtectedRoute element={<IndicatorSettingsPage />} allowedRoles={ADMIN_ROLES} />} />
          <Route path='/indicadores/reporte' element={<ProtectedRoute element={<IndicatorsReportPage />} allowedRoles={ADMIN_ROLES} />} />
          <Route path='/indicadores' element={<ProtectedRoute element={<IndicatorsPage />} allowedRoles={ADMIN_ROLES} />} />
        </Routes>
        </Suspense>
      </Router>
    </Provider>
  );
}


export default App;
